
const BrandSection = () => {
  const brands = [
    {
      name: "Earfit",
      slogan: "시간의 흐름 속, 빛나는 피부 본연의 힘",
      description: "얼핏은 빠르게 변화하는 세상 속에서 '느리지만 확실한 아름다움'을 추구하는 슬로우에이징 스킨케어 브랜드입니다. 마이크로바이옴과 세라마이드 기반의 피부 장벽 케어로, 매일의 피부 루틴을 차분하게 지켜줍니다.",
      tags: ["#클린뷰티", "#슬로우에이징", "#피부장벽케어", "#데일리루틴"],
      image: "https://static.readdy.ai/image/6046fe4c9f6fc7a4bbdf56f9f58ccfeb/e2aa58bf7c55d0e067c0dada31e0e532.png"
    },
    {
      name: "HAU",
      slogan: "과일에서 시작하는 살롱 헤어케어",
      description: "HAU는 정제수를 사용하지 않습니다. 대신, 포뮬라의 38.7%를 망고수로 채웠습니다. 망고수와 파파야, 자몽 추출물의 자연 에너지가 두피 케어와 모발 관리를 하나의 루틴으로 완성합니다.",
      tags: ["#과일헤어케어", "#망고수38.7%", "#살롱헤어케어", "#두피모발케어"],
      image: "https://static.readdy.ai/image/6046fe4c9f6fc7a4bbdf56f9f58ccfeb/f583c4d47427baddff26a9132db64de4.jpeg"
    },
    {
      name: "EjaBon",
      slogan: "피부의 본(本)을 되찾다",
      description: "이자본은 피부가 가장 먼저 무너지는 지점을 찾고, 그 원인부터 다시 설계합니다. '체감'이 아닌 '수치'로 증명되며, 얼굴 전체의 컨디션을 정돈하고 본연의 균형으로 되돌리는 스킨케어입니다.",
      tags: ["#근본케어", "#피부컨디션리셋", "#체감보다수치", "#기능성스킨케어"],
      image: "https://static.readdy.ai/image/6046fe4c9f6fc7a4bbdf56f9f58ccfeb/5016c968b0dcccdca52b141adc091cff.png"
    }
  ];

  return (
    <section id="brand-partners" className="py-32 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-7xl md:text-8xl font-extrabold text-[#1a1a1a] mb-6 text-center leading-tight">
            Brand Partners
          </h2>
          
          <div className="max-w-4xl mx-auto mb-20">
            <p className="text-xl text-[#555555] font-bold tracking-tight text-left" style={{letterSpacing: '-0.02em'}}>
              유행이 아닌 기준을 고민하고, 성분을 넘어 철학으로 브랜드를 봅니다. 우리는 같은 방향을 바라보는 브랜드와 함께합니다.
            </p>
          </div>

          {/* Brand Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {brands.map((brand, index) => (
              <div key={index} className="flex flex-col">
                {/* Image Container */}
                <div className="w-full aspect-[4/5] bg-gray-50 mb-6 overflow-hidden">
                  <img 
                    src={brand.image}
                    alt={brand.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Text Content */}
                <div className="flex flex-col space-y-3">
                  <h3 className="text-2xl font-bold text-[#1a1a1a] text-center">{brand.name}</h3>
                  <p className="text-base font-bold text-[#333333] leading-relaxed text-center">
                    {brand.slogan}
                  </p>
                  <p className="text-sm text-[#666666] leading-relaxed text-left">
                    {brand.description}
                  </p>
                  <div className="flex flex-wrap justify-center gap-2 pt-2">
                    {brand.tags.map((tag, tagIndex) => (
                      <span 
                        key={tagIndex}
                        className="text-xs text-[#999999]"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
